export const teamFoldersSelector = (state) => state.entities.folders.teamFolders;
export const userWorkspaceFoldersSelector = (state) => state.entities.folders.userWorkspaceFolders;
export const userWorkspaceFoldersSizesSelector = (state) => state.entities.folders.userWorkspaceFolderSizes;